// src/components/Workout/ExerciseList.js
import React from "react";
import ExerciseCard from "./ExerciseCard";

const ExerciseList = ({ exercises, onRemoveOptional, openIndex, toggleOpen, handleReplacementChange, handleReplaceSubmit, selectedReplacements }) => {
  return (
    <div>
      {exercises.map((exercise, index) =>
        exercise && exercise.exercise_id ? (
          <ExerciseCard
            key={`${index}-${exercise.exercise_id}`}
            exercise={exercise}
            exercises={exercises}
            onRemoveOptional={onRemoveOptional}
            index={index}
            isOpen={openIndex === index}
            toggleOpen={toggleOpen}
            handleReplacementChange={handleReplacementChange}
            handleReplaceSubmit={handleReplaceSubmit}
            selectedReplacement={selectedReplacements[index]}
          />
        ) : null
      )}
    </div>
  );
};

export default ExerciseList;
